import React from 'react'
import { useUsersPerDay, useWeeklyActiveUsers } from '../../hooks/analytics/useAnalytics'
import GranularitySwitchChart from './GranularitySwitchChart'

const ActiveUsersChart: React.FC = () => {
  const weeklyActiveUsers = useWeeklyActiveUsers()
  const usersPerDay = useUsersPerDay()

  return (
    <GranularitySwitchChart
      title='Active users'
      valueLabel='Unique users'
      daily={{
        isLoading: usersPerDay.isLoading,
        isError: usersPerDay.isError,
        points: (usersPerDay.data ?? []).map(point => ({
          day: point.day,
          value: point.unique_users,
        })),
      }}
      weekly={{
        isLoading: weeklyActiveUsers.isLoading,
        isError: weeklyActiveUsers.isError,
        points: (weeklyActiveUsers.data ?? []).map(point => ({
          day: point.week_start,
          value: point.unique_users,
        })),
      }}
      dailySubtitle={days =>
        `Unique active users per day (last ${days} days). Today is partial.`
      }
      weeklySubtitle={weeks =>
        `Unique active users per week (last ${weeks} weeks). The current week is partial.`
      }
    />
  )
}

export default ActiveUsersChart
